import { Asset } from 'contentful'
import qs from 'qs'

interface Params {
  focus?:
    | 'center'
    | 'top'
    | 'right'
    | 'left'
    | 'bottom'
    | 'top_right'
    | 'top_left'
    | 'bottom_right'
    | 'bottom_left'
    | 'face'
    | 'faces'
  fit?: 'pad' | 'fill' | 'scale' | 'crop' | 'thumb'
  height?: number
  image: Asset
  quality?: number
  width?: number
}

export const getContentfulImageUrl = ({ focus, fit, height, image, quality = 75, width = 4000 }: Params) => {
  // default 16:9 ratio
  let heightRatio = 9 / 16
  if (height && width) {
    heightRatio = height / width
  } else if (image.fields.file.details.image) {
    heightRatio = image.fields.file.details.image.height / image.fields.file.details.image.width
  }
  const setHeight = height || Math.round(width * heightRatio)

  const params = qs.stringify({
    f: focus,
    fit,
  })

  return `https:${image.fields.file.url}?h=${setHeight}&w=${width}&q=${quality}&fm=webp&${params}`
}
